import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getProp from "@insite/mobius/utilities/getProp";
import ADIColors from "@NA/Utils/ADIColors";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { css } from "styled-components";
import { useHistory } from "@NA/Hooks/useHistory";
import Link from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";

interface TextSliderProps {
    textList: { text: string; link: string; linkText: string; dataGaPromo: string; textAlign: string }[];
    color: string;
    interval?: number;
    toggleLoginDrawer: any;
    toggleRewardsDrawer: any;
}

const TextSliderWrapper = styled.div`
    margin: 0 auto;
    overflow: hidden;
    max-width: 450px;
    text-align: center;
    margin: auto auto;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                max-width: 100%;
                margin: auto 15px auto 15px;
                min-height: 25px;
                padding-top: 5px;
                padding-bottom: 5px;
            `,
            css`
                max-width: 100%;
                margin: auto 15px auto 15px;
                text-align: left;
            `,
            css`
                max-width: 450px;
                margin: auto 15px auto 15px;
                text-align: left;
            `,
            null,
        ])}
`;

const TextSliderContent = styled.div<{ $intervalValue?: number, $iterationCount?: any }>`
    white-space: nowrap;
    transition: transform 1000ms ease;
    line-height: normal;
    animation: scroll ${props => props.$intervalValue}s linear  ${props => props.$iterationCount};
    @keyframes scroll {
        0% {
            transform: translateX(200px);
        }
        6.66%,
        20% {
            transform: translateX(0%);
        }
        26.66%,
        40% {
            transform: translateX(-100%);
        }
        46.66%,
        60% {
            transform: translateX(-200%);
        }
        66.66%,
        80% {
            transform: translateX(-300%);
        }
        86.66%,
        98% {
            transform: translateX(-400%);
        }
        100% {
            transform: translateX(calc(-250px * 9));
        }
    }
    &:hover {
        animation-play-state: paused;
    }
    &.paused {
        animation-play-state: paused;
    }
`;

const TextSliderText = styled.span<{ $color?: string }>`
    margin-left: 0;
    display: inline-block;
    width: 100%;
    border-radius: 40px;
    font-size: 14px;
    font-weight: 600;
    white-space: normal;
    vertical-align: middle;
    line-height: 1;
    margin-bottom: 4px;
    color: ${props => (props.$color !== "" ? `${props.$color} !important` : "#fff;")};
    margin-top: 2px;
    > a {
        margin-left: 5px;
        color: ${props => (props.$color !== "" ? `${props.$color} !important` : "#fff;")};
        text-decoration: underline;
        ${TypographyStyle} { 
            color: ${props => (props.$color !== "" ? `${props.$color} !important` : "#fff;")};
        }
        &:focus {
            ${({ theme }) => {
        return breakpointMediaQueries(
            theme, [null, null, null,
            css` 
                        outline-color: ${ADIColors.white};       
                        outline-style: ${getProp("theme.focus.style", "solid")};
                        outline-width: 0px;
                        `,],
            "min",);
    }}                  
        }
        &:focus-visible {
            ${({ theme }) => {
        return breakpointMediaQueries(
            theme, [null, null, null,
            css` 
                    outline-color: ${ADIColors.white};       
                    outline-style: ${getProp("theme.focus.style", "solid")};
                    outline-width: 1px;`,],
            "min",);
    }}
        }   

        
    }
    cursor: default;
`;

const seconds = (value: number, textlist: number) => {
    const listLength = textlist;
    const intervalValue = Math.floor(value / 1000) * listLength + listLength;
    return intervalValue;
};

const TextAutoSlider: React.FC<TextSliderProps> = ({ textList, color, interval, toggleLoginDrawer, toggleRewardsDrawer }) => {
    const [isClicked, setIsClicked] = useState(false);
    const [intervalTimer, setintervalTimer] = useState<number>(2000);
    const [iterationCount, setiterationCount] = useState<any>('infinite');
    const history = useHistory(); 

    useEffect(() => {
        if (interval !== undefined) {
            setintervalTimer(interval);
        }
        if(textList.length == 1){
            setiterationCount(0);
        }
    }, [textList, intervalTimer, isClicked]);

    const renderLink = (url: any) => {
        history.push(url);
        setIsClicked(true);
        toggleLoginDrawer({ loginDrawer: false });
        toggleRewardsDrawer({ rewardsDrawer: false });
        setTimeout(() => {
            setIsClicked(false); 
        }, 200); 
    };

    return (
        <TextSliderWrapper
            onClick={() => {
                setIsClicked(!isClicked);
            }}
        >
            <TextSliderContent
                className={isClicked ? "paused" : ""}
                $intervalValue={seconds(intervalTimer, textList.length)}
                $iterationCount={iterationCount}
            >
                {textList.map(item => (
                    <TextSliderText
                        data-ga-promo={item.dataGaPromo}
                        key={item.linkText}
                        $color={color}
                    >
                        {item.textAlign === 'left' ? (
                            <>
                                <Link href={item.link} onClick={() => renderLink(item.link)}>
                                    {item.linkText}
                                </Link>
                                {item.text && (
                                    <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                )}
                            </>
                        ) : (
                            <>
                                {item.text && (
                                    <span dangerouslySetInnerHTML={{ __html: item.text }} />
                                )}
                                 <Link href={item.link} onClick={() => renderLink(item.link)}>
                                    {item.linkText}
                                </Link>
                            </>
                        )}
                    </TextSliderText>
                ))}
            </TextSliderContent>
        </TextSliderWrapper>
    );
};

export default TextAutoSlider;